import { Component, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectDialogState } from '../../../../dialog/features/dialog.selectors';
import { DialogService } from '../../../../dialog/services/dialog.service';
import { IPaybeeStreamingPayload } from '../../../../event/models/stream-model';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-paybee-stream-modal',
  templateUrl: './paybee-stream-modal.component.html',
  styleUrls: ['./paybee-stream-modal.component.scss']
})
export class PaybeeStreamModalComponent implements OnDestroy {
  public dialog$: Observable<IPaybeeStreamingPayload> = this.store.pipe(select(selectDialogState));

  constructor(
    private store: Store,
    private dialogService: DialogService
  ) {
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  close() {
    this.dialogService.closeDialogSubject.next(null);
  }

  formatBytes(bytes, decimals = 2): string {
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
